export enum FinanceCardEnum {
    Booking = 1,
    TopUp = 2,
    CashOut = 3,
    WalletBalance = 4
}
